module.exports = __webpack_public_path__ + "img/J13080.d376f79a.png";